import { SvgIconProps } from '@mui/material';

import AZFlag from './AZFlag';
import ENFlag from './ENFlag';
import RUFlag from './RUFlag';

const FLAGS: Record<string, (props: SvgIconProps) => JSX.Element> = {
  az: AZFlag,
  ru: RUFlag,
  en: ENFlag,
};

interface Props extends SvgIconProps {
  lang: string;
}

const FlagIcon = ({ lang, sx, ...props }: Props) => {
  const Flag = FLAGS[lang?.toLowerCase()] ?? AZFlag;

  return <Flag sx={{ flexShrink: 0, ...sx }} {...props} />;
};

export default FlagIcon;
